import { createClient } from '../../../server/client/client.no-deps'
import type { ClientLogger } from '../../../shared/lib/ClientLogger.no-deps'
import { Serv_httpRequest, Serv_httpRequestWithOption } from './Serv.httpRequest'

export const Serv_client = createClient(Serv_httpRequest)

export function Serv_clientWithLogger(logger: ClientLogger) {
    return createClient(Serv_httpRequestWithOption({ logger }))
}
